import { Component } from '@angular/core';

@Component({
  selector: 'app-tous-retour-frns',
  templateUrl: './tous-retour-frns.component.html',
  styleUrls: ['./tous-retour-frns.component.scss']
})
export class TousRetourFrnsComponent {}
